<template>
  <section class="content">
    <div class="box box-info">
      <div id="overlay" v-if="loading">
        <div class="spinner"></div>
        <br/>
        <h4>Loading...</h4>
      </div>
      <div class="p-fluid p-formgrid custom-row">
        <div class="p-field custom-col-4">
          <div class="uploadBox">
            <div class="uploadBox-file">
              <label for="accountUpload">Excel Upload </label>
              <InputText id="accountUpload" type="file" @change="onFileSelect" multiple class="form-control" />
            </div>
            <div class="uploadBox-format">
              <a download="itemExcelUpload.xlsx"
                  href="../../../../static/excelFormat/itemExcelUpload.xlsx">Click here to Download Format</a>
            </div>
            <div class="uploadBox-btn">
              <Button class="p-button-raised p-button-info width-auto" label="Upload" @click.prevent="uploadExcel"></Button>
            </div>
          </div>
        </div>
        <div class="p-field custom-col-4">
          <div class="uploadBox">
            <div class="uploadBox-file">
              <label for="accountUpload">Account Excel Upload </label>
              <InputText id="accountUpload" type="file" @change="onFileSelect" multiple class="form-control" />
            </div>
            <div class="uploadBox-format">
              <a download="accontUploadFormat.xlsx"
                href="../../../../static/excelFormat/accontUploadFormat.xlsx">Click here to Download Format</a>
            </div>
            <div class="uploadBox-btn">
              <Button class="p-button-raised p-button-info width-auto" label="Upload" @click.prevent="uploadAccountExcel"></Button>
            </div>
          </div>
        </div>
        <div class="p-field custom-col-4">
          <div class="uploadBox">
            <div class="uploadBox-file">
              <label for="accountUpload">Closing Excel Upload </label>
              <InputText id="accountUpload" type="file" @change="onFileSelect" multiple class="form-control" />
            </div>
            <div class="uploadBox-format">
              <a download="accontUploadFormat.xlsx"
                  href="../../../../static/excelFormat/accontUploadFormat.xlsx">Click here to Download Format</a>
            </div>
            <div class="uploadBox-btn">
              <Button class="p-button-raised p-button-info width-auto" label="Upload" @click.prevent="uploadclosingExcel"></Button>
            </div>
          </div>
        </div>
        <div class="p-field custom-col-4">
          <div class="uploadBox">
            <div class="uploadBox-file">
              <label for="accountUpload">Crm Follow Up Upload </label>
              <InputText id="accountUpload" type="file" @change="onFileSelect" multiple class="form-control" />
            </div>
            <div class="uploadBox-format">
              <a download="followUpFormat.xlsx"
                  href="../../../../static/excelFormat/FollowUpSample.xlsx">Click here to Download Format</a>
            </div>
            <div class="uploadBox-btn">
              <Button class="p-button-raised p-button-info width-auto" label="Upload" @click.prevent="uploadCrmFollowExcel"></Button>
            </div>
          </div>
        </div>
        <div class="p-field custom-col-4">
          <div class="uploadBox">
            <div class="uploadBox-file">
              <label for="accountUpload">Delete Item Excel Upload </label>
              <InputText id="accountUpload" type="file" @change="onFileSelect" multiple class="form-control" />
            </div>
            <div class="uploadBox-format">
              <a download="accontUploadFormat.xlsx"
                  href="../../../../static/excelFormat/deleteItems.xlsx">Click here to Download Format</a>
            </div>
            <div class="uploadBox-btn">
              <Button class="p-button-raised p-button-info width-auto" label="Upload" @click.prevent="uploadItemDeleteExcel"></Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'

export default {
  name: 'excelUpload',
  data() {
    return {
      customerName: '',
      loading: false,
      id: null,
      images: []
    }
  },
  methods: {
    async uploadExcel() {
      let response = ''
      let excelUpload = {
        customerName: 'ssss'
      }
      const formData = new FormData()
      formData.append('excelUpload', JSON.stringify(excelUpload))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('files', this.images[i])
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('uploadExcelItemMaster', formData)
      this.loading = false
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    async uploadAccountExcel() {
      let response = ''
      let excelUpload = {
        customerName: 'ssss'
      }
      const formData = new FormData()
      formData.append('excelUpload', JSON.stringify(excelUpload))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('files', this.images[i])
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('uploadExcelAccoungMaster', formData)
      this.loading = false
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    async uploadclosingExcel() {
      let response = ''
      let excelUpload = {
        customerName: 'ssss'
      }
      const formData = new FormData()
      formData.append('excelUpload', JSON.stringify(excelUpload))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('files', this.images[i])
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('uploadclosingExcel', formData)
      this.loading = false
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    async uploadCrmFollowExcel() {
      let response = ''
      let excelUpload = {
        customerName: 'ssss'
      }
      const formData = new FormData()
      formData.append('excelUpload', JSON.stringify(excelUpload))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('file', this.images[i])
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('uploadFollowUpExcel', formData)
      console.log(response)
      this.loading = false
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    async uploadItemDeleteExcel() {
      let response = ''
      let excelUpload = {
        customerName: 'ssss'
      }
      const formData = new FormData()
      formData.append('excelUpload', JSON.stringify(excelUpload))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('files', this.images[i])
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('uploadDeleteExcel', formData)
      this.loading = false
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    onFileSelect(event) {
      let selectedFile = Array.prototype.slice.call(event.target.files)
      selectedFile.forEach(f => {
        this.images.push(f)
      //   let reader = new FileReader()
      //   reader.onload = (e) => {
      //     this.url.push(e.target.result)
      //   }
      //   reader.readAsDataURL(f)
      })
    },
    reset() {
      this.customerName = ''
      this.images = []
      this.loading = false
    }
  },
  components: {
    Button,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css"/>



// WEBPACK FOOTER //
// excelUpload.vue?7c60a902